module.exports = __webpack_public_path__ + "img/en.aca3a581.png";